import { render, staticRenderFns } from "./AutoCompleteEquipamento.vue?vue&type=template&id=fdab6436&"
import script from "./AutoCompleteEquipamento.vue?vue&type=script&lang=ts&"
export * from "./AutoCompleteEquipamento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports